export const faqData = [
	{
		question: "Why is Kevin Kotlin Bunny?",
		answer: "At Onthego Delivery Inc., we have a special individual handling all Kotlin processes. To fuel his motivations, Kevin dreams, contemplates, and thinks about bunnies, providing our team with excellent bunny supports we need.",
	},
];